import { render, staticRenderFns } from "./InternetAlert.vue?vue&type=template&id=b50ef0e0"
import script from "./InternetAlert.vue?vue&type=script&lang=js"
export * from "./InternetAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports